import auth from '../AuthForms.module.css';
const SignUpForm = () => {
    return (
        <form className="formulariologin text-center" action="">
            <h2 className={auth.formTitle}>Registro</h2>
            <div className="form-group">
                <input type="text" className={`${auth.formInput} my-2`} placeholder="Nombre" aria-describedby="nameHelp" />
            </div>
            <div className="form-group">
                <input type="email" className={auth.formInput} placeholder="Correo" aria-describedby="emailHelp" />
            </div>
            <div className="form-group">
                <input type="password" className={auth.formInput} placeholder="Contraseña" aria-describedby="emailHelp" />
            </div>
            <div>
                <button type="submit" className={auth.submitButton}>Registrarse</button>
            </div>

        </form>
    )
}
export default SignUpForm